import React from "react";

function Banner() {
  return (
    <div>
      <div>
        <h1 className="brand drop">Event(ful) &#127881;</h1>
      </div>
    </div>
  );
}

export default Banner;
